import { Icon } from "@iconify/react";
import React from "react";
import { Col, Dropdown, Row } from "react-bootstrap";
import CreateSurvey from "../admin-component/survey/CreateSurvey";
import HeaderSetting from "../admin-component/HeaderSetting";
import PageNav from "./PageNav";
import AdminManual from "../../assets/user-manuals/AdminManual.pdf";
import SuyveyorUserManual from "../../assets/user-manuals/AdminManual.pdf";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import {
  closeClientModal,
  closeSurveyModal,
  closeUserModal,
  modalSelector,
  openClientModal,
  openSurveyModal,
  openUserModal,
} from "../../redux/modalSlice";
import { resetSurvey } from "../../redux/surveySlice";
import AddNewClient from "../admin-component/clients/AddNewClient";
import { resetClient } from "../../redux/clientSlice";
import AddNewUser from "../admin-component/user/AddNewUser";
import { resetUser } from "../../redux/userSlice";
import { CSV_EXPORT, FIELDS } from "../../constants/constants";
import { CSVLink } from "react-csv";
import { Link, useNavigate } from "react-router-dom";
import spinnerSvc from "../../services/spinner-service";

const HeaderMain = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user"));
  const path = window.location.pathname;
  const { modal } = useSelector(modalSelector);

  const downloadUserManual = () => {
    const url =
      user?.role === "admin"
        ? `https://${process.env.REACT_APP_STORAGE_ACCOUNT_NAME}.blob.core.windows.net/files/AdminUserManual.pdf`
        : `https://${process.env.REACT_APP_STORAGE_ACCOUNT_NAME}.blob.core.windows.net/files/SurveyorUserManual.pdf`;
    const fileName =
      user?.role === "admin" ? "Admin-User-Manual" : "Suyveyor-User-Manual";

    axios({
      url,
      method: "GET",
      responseType: "blob", // important
    })
      .then((response) => {
        const link = document.createElement("a");
        link.href = URL.createObjectURL(new Blob([response.data]));
        link.setAttribute("download", `${fileName}.pdf`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch((error) => console.log(error));
  };
  return (
    <>
      <div className="dashboardHeader">
        <Row className="align-items-center">
          <Col xs="6">
            <PageNav />
          </Col>
          <Col xs="6">
            <div className="topRightMenu">
              {path === "/surveys" && (
                <>
                  {/* <div className="upload-btn me-2">
                    <input type="file" className="fileUpload" />
                    <button className="btn btn-indigo">
                      Upload File
                      <i className="ms-2">
                        <Icon icon="uil:upload-alt" />
                      </i>
                    </button>
                  </div>
           
                  <div className="upload-btn me-2">
                    
                  </div>   */}
                </>
              )}
              <Dropdown align="end">
                <Dropdown.Toggle
                  className="btn cta-primary-light"
                  id="dropdown-basic"
                >
                  Add new{" "}
                  <i className="ms-2">
                    <svg
                      width="16"
                      height="17"
                      viewBox="0 0 16 17"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M8 3.1665L8 13.8332"
                        stroke="#006666"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M13.3333 8.5L2.66663 8.5"
                        stroke="#006666"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </i>
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item
                    href="#"
                    onClick={() => {
                      dispatch(openClientModal());
                      dispatch(resetClient());
                    }}
                  >
                    Client
                  </Dropdown.Item>
                  <Dropdown.Item
                    href="#"
                    onClick={() => {
                      dispatch(openSurveyModal());
                      dispatch(resetSurvey());
                    }}
                  >
                    Survey
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() =>
                      navigate("/templates", { state: { isNew: true } })
                    }
                  >
                    Template
                  </Dropdown.Item>
                  <Dropdown.Item
                    href="#"
                    onClick={() => {
                      dispatch(openUserModal());
                      dispatch(resetUser());
                    }}
                  >
                    User
                  </Dropdown.Item>
                  <Dropdown.Item href="/lookup">Lookup</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
              <HeaderSetting />

              <a
                href={user?.role === "admin" ? AdminManual : SuyveyorUserManual}
                download={
                  user?.role === "admin"
                    ? "Admin-User-Manual"
                    : "Suyveyor-User-Manual"
                }
                target="_blank"
                rel="noreferrer"
                className="ctaHelp"
              >
                {/* <Link className="ctaHelp" onClick={downloadUserManual}> */}
                <i>
                  <Icon icon="fluent:book-search-20-regular" />
                </i>
                {/* </Link> */}
              </a>
            </div>
          </Col>
        </Row>
      </div>
      <CreateSurvey
        show={modal.surveyModal}
        onHide={() => {
          dispatch(closeSurveyModal());
          dispatch(resetSurvey());
        }}
      />
      <AddNewClient
        show={modal.clientModal}
        onHide={() => {
          dispatch(closeClientModal());
          dispatch(resetClient());
        }}
      />
      <AddNewUser
        show={modal.userModal}
        onHide={() => dispatch(closeUserModal())}
      />
    </>
  );
};

export default HeaderMain;
